// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(status) {
  switch (status) {
    case "Closed" :
        return /* Closed */1;
    case "Forwarded" :
        return /* Others */{
                _0: "Forwarded"
              };
    case "Open" :
        return /* Open */0;
    case "Re-opened" :
        return /* Others */{
                _0: "Re-opened"
              };
    case "Under Processing" :
        return /* Others */{
                _0: "Under Processing"
              };
    case "Unresolved" :
        return /* Others */{
                _0: "Unresolved"
              };
    default:
      return ErrorUtils$Catalyst.raiseError("TicketStatus.re", "Invalid ticket status", status);
  }
}

function toString(status) {
  if (typeof status === "number") {
    if (status !== 0) {
      return "Closed";
    } else {
      return "Open";
    }
  } else {
    return status._0;
  }
}

function getListOfTicketStatus(param) {
  return {
          hd: /* Open */0,
          tl: {
            hd: /* Closed */1,
            tl: /* [] */0
          }
        };
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

var t_encode = toString;

export {
  fromString ,
  toString ,
  getListOfTicketStatus ,
  t_decode ,
  t_encode ,
  
}
/* No side effect */
